<template>
    <v-select
        variant="outlined"
        density="compact"
        :label="label === undefined ? t('language') : label"
        :items="languages"
        v-model="language"
    ></v-select>
</template>

<script>
import { usePitStoreBasics } from "@/stores/app_common";

export default {
    setup() { return { ...usePitStoreBasics() } },
    props: ["modelValue", "allow_default", "label"],
    data: () => ({
        languages: [
            { title: "Dutch (nl)", value: "nl" },
            { title: "English (en)", value: "en" },
            { title: "Spanish (es)", value: "es" },
            { title: "Polish (pl)", value: "pl" },
        ],
        language: "",
    }),
    watch: {
        modelValue: {
            handler: function (v) {
                this.language = v;
            },
            immediate: true,
        },
        language(lang) {
            this.$emit("update:modelValue", lang);
        },
    },
    mounted() {
        if (this.allow_default) {
            this.languages.unshift({ title: this.t("default"), value: null });
        }
    },
};
</script>